/** The story's distributions, for the list page. */
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../services/queryKeys";
import { getApiErrorMessage } from "../services/apiErrors";
import { listDistributions, type DistributionListScope } from "../services/distributions/distributionsApi";
import type { DistributionSummaryApi } from "../services/distributions/distributions.types";

export interface UseDistributionsResult {
  distributions: DistributionSummaryApi[];
  isLoading: boolean;
  errorMessage: string | null;
  refetch: () => void;
}

/** `scope` "archived" lists only the archived ones (read-only, restorable). */
export function useDistributions(storyId: string | undefined, scope: DistributionListScope = "current"): UseDistributionsResult {
  const query = useQuery({
    queryKey: scope === "archived" ? queryKeys.distributions.archivedList(storyId ?? "") : queryKeys.distributions.list(storyId ?? ""),
    queryFn: () => listDistributions(storyId as string, scope),
    enabled: Boolean(storyId),
  });
  return {
    distributions: query.data?.items ?? [],
    isLoading: query.isLoading,
    errorMessage: query.isError ? getApiErrorMessage(query.error, "Couldn’t load the distributions for this story.") : null,
    refetch: () => void query.refetch(),
  };
}
